export default "__VITE_ASSET__BgsJaJaj__"